import { useDetailApi } from "../../../swr/useApi";
import type { BrandDto } from "../../../api";
import { brandsService } from "../../api_client";

export function useBrand(id?: number | null) {
    return useDetailApi<BrandDto>({
        key: `brand-${id ?? "none"}`,
        serviceMethod: async () => await brandsService.getBrandById(id as number),
        options: {
            isPaused: () => !id,
        },
    });
}
